module.exports = __webpack_public_path__ + "static/media/Retreats-04.784bc67a.webp";